/* eslint-disable import/default */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, memo, useEffect } from 'react'
import {
  View,
  Dimensions,
  StatusBar,
  ImageBackground,
  TouchableOpacity,
  Animated,
  Platform,
  ScrollView,
  BackHandler,
  ColorPropType
} from 'react-native'
import PropTypes from 'prop-types'
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context'
import Carousel, { Pagination } from 'react-native-snap-carousel'
import { Colors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'
import { Icon } from '@vfgroup-oneplatform/foundation/Components'
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'
import LottieView from 'lottie-react-native'
// import RNShake from 'react-native-shake'
import ContentLoader, { Rect } from 'react-content-loader/native'
// import Share from 'react-native-share'
import ViewShot, { captureRef } from 'react-native-view-shot'
import LinearGradient from 'react-native-linear-gradient'
// eslint-disable-next-line import/no-named-as-default
import WebView from 'react-native-webview'


import VfText from '../../Components/VfText'
import VFButton from '../../Components/VFButton'
import SelectGroup from '../../Components/SelectGroup'
import Modal from '../../Components/Modal'
import MigrationLottie from '../../Components/MigrationLottie'

import styles, { itemStyles } from './Shake.Styles'
import images from '../../Themes/Images'
import { fall, winter, web } from '../../Themes/Themes'
import { stackAnimatedStyles, stackScrollInterpolator } from './Shake.Animations'


const { width, height } = Dimensions.get('screen')

import _Modal from 'react-native-modal'

const BUTTON_POINTER_EVENTS = {
  true: 'auto',
  false: 'none'
}

const SCREENS = {
  shaking: 'shaking',
  gift: 'gift',
  shakeWithVcoins: 'shakeWithVcoins',
  shakeAgain: 'shakeAgain',
  limitReached: 'limitReached',
  quote: 'quote'
}

const MODALS = {
  error: 'error',
  modal: 'modal',
  details: 'details'
}

const animations = [
  'lottie_bundles',
  'lottie_celebrate',
  'lottie_chat',
  'lottie_promo',
  'lottie_data',
  'lottie_coupon',
  'lottie_vcoins'
]

const Themes = { fall, winter, web }

function QuoteCard(props) {
  const { desc, isLoading, index, selected } = props

  const screnshot = useRef()

  return (
    <View style={itemStyles.cardContainer} pointerEvents={index === selected ? 'auto' : 'none'} >
      <ViewShot
        ref={ref => (screnshot.current = ref)}
        style={itemStyles.quoteWrapper}
      >
        <Icon
          name={images.quoteLeft}
          size={40}
          type="image"
          resizeMode="contain"
          style={{ alignSelf: 'flex-start' }}

        />

        <VfText
          i18nKey={desc}
          align="center"
          size="h4"
          isLoading={isLoading}
          style={itemStyles.quoteDesc}
        />
        <Icon
          name={images.quoteRight}
          size={40}
          type="image"
          resizeMode="contain"
          style={itemStyles.rightQoute}
        />
      </ViewShot>
    </View>
  )
}
QuoteCard.defaultProps = {
  namePlaceHolders: [],
  descPlaceHolders: []
}
QuoteCard.propTypes = {
  type: PropTypes.any,
  onPress: PropTypes.func,
  name: PropTypes.string,
  namePlaceHolders: PropTypes.array,
  desc: PropTypes.string,
  descPlaceHolders: PropTypes.array,
  isLoading: PropTypes.bool,
  index: PropTypes.number,
  selected: PropTypes.number
}

function SpecialCard({
  style,
  theme,
  children
}) {
  const { topLeft, topRight, bottomLeft, bottomRight } = Themes[theme]

  return (
    <View style={[style, styles.specialCardContainer]}>
      <Icon name={topLeft} size={100} type="image" resizeMode="cover" style={styles.topLeft} />
      <Icon name={topRight} size={100} type="image" resizeMode="cover" style={styles.topRight} />
      <Icon name={bottomLeft} size={100} type="image" resizeMode="cover" style={styles.bottomLeft} />
      <Icon name={bottomRight} size={100} type="image" resizeMode="cover" style={styles.bottomRight} />
      {children}
    </View>
  )
}
SpecialCard.propTypes = {
  style: PropTypes.object,
  theme: PropTypes.string,
  children: PropTypes.any
}

function Card(props) {
  const {
    type,
    name,
    namePlaceHolders,
    desc,
    descPlaceHolders,
    isLoading,
    index,
    selected,
    theme
  } = props

  if (type === 'quote') {
    return <QuoteCard {...props} index={index} selected={selected} />
  }

  const Container = type === 'promo' ? SpecialCard : View

  return (
    <View style={itemStyles.cardContainer} pointerEvents={index === selected ? 'auto' : 'none'}>
      <Container style={itemStyles.card} theme={theme}>
        <LottieView
          source={images['lottie_' + type]}
          autoPlay={true}
          loop={true}
          resizeMode="cover"
          imageAssetsFolder={'../../Images/lottieIcons'}
          style={itemStyles.animatedIcon}
        />
        <VfText
          i18nKey={name}
          placeHolders={namePlaceHolders}
          size="h2"
          weight="bold"
          align="center"
          numberOfLines={2}
          isLoading={isLoading}
          style={itemStyles.title}
        />
        <VfText
          i18nKey={desc}
          placeHolders={descPlaceHolders}
          align="center"
          size="h5"
          numberOfLines={3}
          isLoading={isLoading}
        />
      </Container>
    </View>
  )
}
Card.defaultProps = {
  namePlaceHolders: [],
  descPlaceHolders: []
}
Card.propTypes = {
  type: PropTypes.any,
  onPress: PropTypes.func,
  name: PropTypes.string,
  namePlaceHolders: PropTypes.array,
  desc: PropTypes.string,
  descPlaceHolders: PropTypes.array,
  isLoading: PropTypes.bool,
  index: PropTypes.number,
  selected: PropTypes.number,
  theme: ColorPropType
}

const AnimatedButton = memo(function Button(props) {
  const { visible, title, ...rest } = props

  const anim = useRef(new Animated.Value(0)).current
  const [isVisible, setVisible] = useState(visible)
  const [buttonTitle, setTitle] = useState(title)
  const onComplete = () => {
    setVisible(visible)
  }

  useEffect(() => {
    if (visible) {
      if (title !== buttonTitle) {
        if (isVisible) {
          setTimeout(() => {
            setTitle(title)
          }, 150)
          Animated.sequence([
            Animated.timing(anim, {
              toValue: 0,
              duration: 150,
              useNativeDriver: true
            }),
            Animated.timing(anim, {
              toValue: 1,
              duration: 150,
              useNativeDriver: true
            })
          ]).start(onComplete)
        } else {
          setTitle(title)
          Animated.timing(anim, {
            toValue: 1,
            duration: 150,
            useNativeDriver: true
          }).start(onComplete)
        }
      } else {
        Animated.timing(anim, {
          toValue: 1,
          duration: 150,
          useNativeDriver: true
        }).start(onComplete)
      }
    } else {
      Animated.timing(anim, {
        toValue: 0,
        duration: 150,
        useNativeDriver: true
      }).start(onComplete)
    }
  }, [isVisible, title, visible])

  return (
    <Animated.View
      pointerEvents={BUTTON_POINTER_EVENTS[visible]}
      style={{
        opacity: anim,
        transform: [{ scaleY: anim }]
      }}>
      <VFButton title={buttonTitle} {...rest} />
    </Animated.View>
  )
})
AnimatedButton.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string
}

function ShakeAnim(props) {
  const {
    onShake,
    setLoading,
    displayOffers,
    displayError,
    showLimitReached,
    textColor
  } = props

  const anim = useRef(null)
  const [shakeEvents, setShakeEvents] = useState([])
  const [isAnimating, setIsAnimating] = useState(false)
  const scaleValue = useRef(new Animated.Value(1)).current
  const trnaslateValue = useRef(new Animated.Value(1)).current

  const shake = () => {
    anim.current?.play?.()
    setShakeEvents(prev => {
      prev.push(1)
      return [...prev]
    })
  }

  useEffect(() => {
    if (shakeEvents.length === 1) {
      setIsAnimating(true)
      setTimeout(() => {
        onShake?.('shake', {
          onSuccess: () => {
            displayOffers?.()
            setShakeEvents([])
          },
          onError: e => {
            if (e.reason === '402') {
              setLoading(true)
              onShake?.('vcoins_product', {
                onSuccess: () => {
                  setLoading(false)
                },
                onError: () => {
                  //displayError('shake_button_error_general', e.message)
                  setLoading(false)
                }
              })
              showLimitReached()
            } else {
              displayError(e.message)
            }
            setShakeEvents([])
          }
        })
      }, 2000)
    }
    // else {
    //   anim.current?.reset?.()
    //   anim.current?.play?.(10, 300)
    // }
  }, [shakeEvents.length])

  // useEffect(() => {
  //   const subscription = RNShake.addListener(shake)
  //   return () => subscription.remove()
  // }, [])

  const scaleDown = () => {
    setTimeout(() => {
      shake()
    }, 300)
    Animated.sequence([
      Animated.timing(trnaslateValue, { toValue: 5, duration: 30, useNativeDriver: true }),
      Animated.timing(scaleValue, { toValue: 0.95, duration: 30, useNativeDriver: true }),
      Animated.timing(trnaslateValue, { toValue: 10, duration: 30, useNativeDriver: true }),
      Animated.timing(scaleValue, { toValue: 0.9, duration: 30, useNativeDriver: true }),
      Animated.timing(trnaslateValue, { toValue: 5, duration: 30, useNativeDriver: true }),
      Animated.timing(scaleValue, { toValue: 0.85, duration: 30, useNativeDriver: true }),
      Animated.timing(trnaslateValue, { toValue: 0, duration: 30, useNativeDriver: true }),
      Animated.timing(scaleValue, { toValue: 0.85, duration: 50, useNativeDriver: true }),
      Animated.timing(trnaslateValue, { toValue: -5, duration: 100, useNativeDriver: true }),
      Animated.timing(trnaslateValue, { toValue: -10, duration: 100, useNativeDriver: true })
    ]).start();
  }

  return <View style={styles.shakeAnimContainer}>
    {shakeEvents.length === 0 && Dimensions.get('window').width < 700 && <VfText
      i18nKey="shake_start_shaking"
      size="h4"
      align="center"
      color={textColor}
    />}
    <div style={{ cursor: 'pointer', marginRight: '-60px' }} onClick={() => {
      scaleDown()
    }}>
      <Animated.View
        style={{
          display: isAnimating ? 'none' : 'block',
          transform: [{
            translateX: trnaslateValue,
          }, {
            scale: scaleValue
          }]
        }}
      >
        <img src='images/img_0.png' height={Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 365 : 200} width={Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 365 : 200} />
      </Animated.View>
      <LottieView
        source={require('./data.json')}
        autoPlay={false}
        loop={true}
        resizeMode="cover"
        style={{
          ...Platform.select({
            web: {
              height: 600,
              marginTop: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? '-65%' : null,
              display: isAnimating ? 'block' : 'none',
            },
            default: {}
          })
        }}
        ref={ref => {
          anim.current = ref
        }}
      // imageAssetsFolder={'lottie/shakeAnim/images'}
      />
    </div>
    {shakeEvents.length === 0 && Dimensions.get('window').width > 700 && <VfText
      i18nKey="shake_web_start_shaking"
      size="h4"
      align="center"
      color={textColor}
      style={{ fontSize: 20, fontWeight: 700, color: '#333333' }}
    />}
    {shakeEvents.length === 0 && <VfText
      i18nKey="shake_chose_gifts_desc"
      size="h5"
      align="center"
      color={textColor}
      style={styles.shakeAnimDesc}
    />}
  </View>
}
ShakeAnim.propTypes = {
  onShake: PropTypes.func,
  setLoading: PropTypes.func,
  displayOffers: PropTypes.func,
  displayError: PropTypes.func,
  showLimitReached: PropTypes.func,
  textColor: ColorPropType
}

function Shake(props) {
  const {
    isContentLoading,
    onClose,
    navigateToBundles,
    getProducts,
    productDetails: { id, cards = [], options = [] },
    orderProduct
  } = props

  const [theme] = useState('fall')

  const {
    background,
    gradient = '',
    accent,
  } = Themes[Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 'web' : 'fall']

  const [order, setOrder] = useState({
    loading: false,
    button: 0
  })

  const [loading, setLoading] = useState(false)
  const [quote, setQuote] = useState('')
  const [orderedProduct, setOrderedProduct] = useState({})

  const insets = useSafeAreaInsets()
  const carueselRef = useRef(null)
  const [selected, setSelected] = useState(0)
  const themeColors = useTheme()

  const onCarouselItemChange = index => {
    setSelected(index)
  }
  const select = index => {
    carueselRef.current?.snapToItem(index)
    setSelected(index)
  }

  const [screen, setScreen] = useState(SCREENS.shaking)

  const [modal, setModal] = useState({
    isVisible: false,
    icon: '',
    header: '',
    selectedPlaceHolders: [],
    title: '',
    titlePlaceHolders: [],
    desc: '',
    descPlaceHolders: [],
    primaryLabel: '',
    primaryPlaceHolders: [''],
    primaryAction: null,
    secondaryLabel: '',
    secondaryAction: null,
    onHide: null
  })

  const [error, setError] = useState({
    isVisible: false,
    title: '',
    desc: '',
    primaryLabel: '',
    primaryAction: null,
    secondaryLabel: null,
    secondaryAction: null,
    onHide: null
  })

  const [details, setDetails] = useState({
    isVisible: false,
    onHide: null
  })

  // IOS cannot show 2 modals at the same time (unless they are inside one another, which is not the case), when you try and open another modal when the other is open the state changes but the modal doesnt open and the screen frezes, a solution for that was putting the modal in a container with the height of 0 but that won't solve visibility of the modal, closing the first modal and opening the other doesn't solve the isue either because the first modal needs to be completely dismissed in order for the other one to open, the solution is as following, request to open the modal, check if there is any modal open, if not then open the new modal, if yes, dismiss the first modal and add the opening of the new modal as a callback onHide of the first modal (using the useEffect hook because the visibility state of the modal is not updated in display and dismiss functions)
  const [openRequest, requestToOpen] = useState(null)
  useEffect(() => {
    if (openRequest) {
      if (openRequest === MODALS.error) {
        if (modal.isVisible) {
          dismissModal(() => {
            setError(prev => {
              return { ...prev, isVisible: true }
            })
            // changeStatusBar('light-content', Colors.blackRGBA(0.5))
          })
        } else if (details.isVisible) {
          dismissDetails(() => {
            setError(prev => {
              return { ...prev, isVisible: true }
            })
            // changeStatusBar('light-content', Colors.blackRGBA(0.5))
          })
        } else {
          setError(prev => {
            return { ...prev, isVisible: true }
          })
          //changeStatusBar('light-content', Colors.blackRGBA(0.5))
        }
      } else if (openRequest === MODALS.modal) {
        if (error.isVisible) {
          dismissError(() => {
            setModal(prev => {
              return { ...prev, isVisible: true }
            })
            // changeStatusBar('dark-content', Colors.white)
          })
        } else if (details.isVisible) {
          dismissDetails(() => {
            setModal(prev => {
              return { ...prev, isVisible: true }
            })
            //changeStatusBar('dark-content', Colors.white)
          })
        } else {
          setModal(prev => {
            return { ...prev, isVisible: true }
          })
          // changeStatusBar('dark-content', Colors.white)
        }
      } else if (openRequest === MODALS.details) {
        if (error.isVisible) {
          dismissError(() => {
            setDetails(prev => {
              return { ...prev, isVisible: true }
            })
            //changeStatusBar('light-content', Colors.blackRGBA(0.5))
          })
        } else if (modal.isVisible) {
          dismissModal(() => {
            setDetails(prev => {
              return { ...prev, isVisible: true }
            })
            //changeStatusBar('light-content', Colors.blackRGBA(0.5))
          })
        } else {
          setDetails(prev => {
            return { ...prev, isVisible: true }
          })
          // changeStatusBar('light-content', Colors.blackRGBA(0.5))
        }
      }
      requestToOpen(null)
    }
  }, [openRequest])

  function dismissDetails(onHide = () => { }) {
    // changeStatusBar('light-content', Colors.transparent)
    setDetails({
      onHide: onHide
    })
  }
  function displayDetails() {
    setDetails({
      isVisible: true,
      onHide: () => { }
    })
  }

  function dismissModal(onHide = () => { }) {
    // changeStatusBar('light-content', Colors.transparent)
    setModal({
      isVisible: false,
      icon: '',
      header: '',
      selectedPlaceHolders: [],
      title: '',
      titlePlaceHolders: [],
      desc: '',
      descPlaceHolders: [],
      primaryLabel: '',
      primaryPlaceHolders: [],
      primaryAction: null,
      secondaryLabel: null,
      secondaryAction: null,
      onHide: onHide
    })
  }
  function displayModal(
    icon = '',
    header = '',
    selectedPlaceHolders = [],
    title = '',
    titlePlaceHolders = [],
    desc = '',
    descPlaceHolders = [],
    primaryLabel = 'shake_button_go_back',
    primaryPlaceHolders = [],
    primaryAction = () => dismissModal(),
    secondaryLabel = '',
    secondaryAction = null,
  ) {
    setModal({
      icon: icon,
      header: header,
      selectedPlaceHolders: selectedPlaceHolders,
      title: title,
      titlePlaceHolders: titlePlaceHolders,
      desc: desc,
      descPlaceHolders: descPlaceHolders,
      primaryLabel: primaryLabel,
      primaryPlaceHolders: primaryPlaceHolders,
      primaryAction: primaryAction,
      secondaryLabel: secondaryLabel,
      secondaryAction: secondaryAction
    })
    requestToOpen(MODALS.modal)
  }
  function dismissError(onHide = () => { }) {
    setError({
      isVisible: false,
      title: '',
      desc: '',
      primaryLabel: null,
      primaryAction: null,
      secondaryLabel: null,
      secondaryAction: null,
      onHide: onHide
    })
    // changeStatusBar('light-content', Colors.transparent)
  }
  function displayError(
    title = '',
    desc = '',
    primaryLabel = 'shake_button_go_back',
    primaryAction = () => dismissError(),
    secondaryLabel = '',
    secondaryAction = null,
  ) {
    setError({
      title: title,
      desc: desc,
      primaryLabel: primaryLabel,
      primaryAction: primaryAction,
      secondaryLabel: secondaryLabel,
      secondaryAction: secondaryAction
    })
    requestToOpen(MODALS.error)
  }

  const renderShakeContent = () => {
    if (screen === SCREENS.shaking) {
      return (
        <ShakeAnim
          onShake={getProducts}
          setLoading={setLoading}
          displayOffers={() => setScreen(SCREENS.gift)}
          showLimitReached={() => setScreen(SCREENS.limitReached)}
          displayError={message =>
            displayError(
              'shake_button_error_general',
              message || '',
              'shake_button_try_again',
              () => dismissError(),
              '',
              null,
            )
          }
          textColor={accent}
        />
      )
    }

    if (screen === SCREENS.quote) {
      return (
        <>
          <View style={styles.caruselWrapper}>
            <View style={styles.caruselContainer}>
              <Card
                index={0}
                type="chat"
                name="Quote"
                desc={quote}
                selected={selected}
              />
            </View>
          </View>
          <View style={styles.sectionTitle}>
            <VfText
              i18nKey={
                options.length === 1
                  ? 'shake_another_left_today'
                  : 'shake_again_tomorrow'
              }
              size="h3"
              color={accent}
              loadingBackgroundColor={gradient[0]}
              loadingForegroundColor={accent}
              isLoading={loading}
            />
          </View>
          <View style={styles.inlineButtons}>
            {loading ? (
              <View style={styles.leftButtonContentLoader}>
                <ContentLoader
                  speed={2}
                  width={(width - 48) / 2}
                  height={42}
                  backgroundColor={Colors.white}
                  foregroundColor={Colors.vfRed}>
                  <Rect
                    x="16"
                    y="10"
                    rx="6"
                    ry="6"
                    width={`${(width - 48) / 2 - 32}`}
                    height="22"
                  />
                </ContentLoader>
              </View>
            ) : options.length === 1 ? (
              <VFButton
                icon={images.VCoins}
                title="shake_shake_again"
                type="light"
                onPress={() => {
                  displayModal(
                    'lottie_vcoins',
                    'shake_re_shake',
                    [],
                    options[0].name,
                    [],
                    options[0].desc,
                    [],
                    'shake_button_yes_continue',
                    [],
                    () => {
                      setOrder({
                        loading: true,
                        button: 1
                      })
                      orderProduct(id || '', options[0].id || '', 'vcoins_product', {
                        onSuccess: res => {
                          setOrderedProduct(res)
                          dismissModal()
                          setScreen(SCREENS.shakeAgain)
                          setOrder({
                            loading: false,
                            button: 0
                          })
                        },
                        onError: e => {
                          if (e.reason === '405') {
                            displayError('shake_not_enough_vcoins', e.message, 'shake_button_close')
                          } else {
                            displayError('shake_button_error_general', e.message)
                          }
                          setOrder({
                            loading: false,
                            button: 0
                          })
                        }
                      })
                    },
                    'shake_button_go_back',
                    () => {
                      dismissModal()
                    },
                  )
                }}
                style={styles.leftButton}
              />
            ) : (
              <VFButton
                title="shake_back_to_dashboard"
                type="light"
                onPress={() => closeScreen()}
                style={styles.leftButton}
              />
            )}
            <VFButton
              icon={images.priceTag}
              iconColor={Colors.white}
              title="shake_zbulo_ofertat"
              type="dark"
              onPress={() => goToBundles()}
              style={styles.rightButton}
            />
          </View>
        </>
      )
    }

    if (screen === SCREENS.limitReached) {
      return (
        <>
          <View style={styles.caruselWrapper}>
            <View style={styles.caruselContainer}>
              <Card
                index={0}
                type="bundles"
                name="shake_explore_offers_title"
                desc="shake_explore_offers_desc"
                selected={selected}
              />
            </View>
          </View>
          <VfText
            i18nKey={
              options.length === 1
                ? 'shake_buy_another_today'
                : 'shake_again_tomorrow'
            }
            size="h3"
            color={accent}
            style={styles.sectionTitle}
            loadingBackgroundColor={gradient[0]}
            loadingForegroundColor={Colors.veryLightPinkTwo}
            isLoading={loading}
          />
          <View style={styles.inlineButtons}>
            {loading
              ? (
                <View style={styles.leftButtonContentLoader}>
                  <ContentLoader
                    speed={2}
                    width={(width - 48) / 2}
                    height={42}
                    backgroundColor={Colors.white}
                    foregroundColor={Colors.vfRed}>
                    <Rect
                      x="16"
                      y="10"
                      rx="6"
                      ry="6"
                      width={`${(width - 48) / 2 - 32}`}
                      height="22"
                    />
                  </ContentLoader>
                </View>
              )
              : options.length === 1
                ? (
                  <VFButton
                    icon={images.VCoins}
                    title="shake_shake_again"
                    type="light"
                    onPress={() => {
                      displayModal(
                        'lottie_vcoins',
                        'shake_re_shake',
                        [],
                        options[0].name,
                        [],
                        options[0].desc,
                        [],
                        'shake_button_yes_continue',
                        [],
                        () => {
                          setOrder({
                            loading: true,
                            button: 1
                          })
                          orderProduct(id || '', options[0].id || '', 'vcoins_product', {
                            onSuccess: res => {
                              setOrderedProduct(res)
                              dismissModal()
                              setScreen(SCREENS.shakeAgain)
                              setOrder({
                                loading: false,
                                button: 0
                              })
                            },
                            onError: e => {
                              if (e.reason === '405') {
                                displayError('shake_not_enough_vcoins', e.message, 'shake_button_close')
                              } else {
                                displayError('shake_button_error_general', e.message)
                              }
                              setOrder({
                                loading: false,
                                button: 0
                              })
                            }
                          })
                        },
                        'shake_button_go_back',
                        () => {
                          dismissModal()
                        },
                      )
                    }}
                    style={styles.leftButton}
                  />
                )
                : (
                  <VFButton
                    title="shake_back_to_dashboard"
                    type="light"
                    onPress={() => closeScreen()}
                    style={styles.leftButton}
                  />
                )}
            <VFButton
              icon={images.priceTag}
              iconColor={Colors.white}
              title="shake_zbulo_ofertat"
              type="dark"
              onPress={() => goToBundles()}
              style={styles.rightButton}
            />
          </View>
        </>
      )
    }

    if (screen === SCREENS.shakeAgain) {
      return (
        <>
          <View style={styles.caruselWrapper}>
            <View style={styles.caruselContainer}>
              <Card
                index={0}
                type="bundles"
                name={orderedProduct?.name}
                desc={orderedProduct?.desc}
                selected={selected}
              />
            </View>
          </View>
          <VfText
            i18nKey="shake_another_left_today"
            size="h3"
            color={themeColors.colors.textColor}
            style={styles.sectionTitle}
            loadingBackgroundColor={Colors.white}
            loadingForegroundColor={Colors.veryLightPinkTwo}
            isLoading={loading}
          />
          <View style={styles.inlineButtons}>
            <VFButton
              title="shake_try_now"
              type="light"
              onPress={() => setScreen(SCREENS.shaking)}
              style={styles.leftButton}
            />
            <VFButton
              title="shake_later_today"
              type="dark"
              onPress={() => closeScreen()}
              style={styles.rightButton}
            />
          </View>
        </>
      )
    }

    if (screen === SCREENS.shakeWithVcoins) {
      return (
        <>
          <View style={styles.caruselWrapper}>
            <View style={styles.caruselContainer}>
              <Card
                index={0}
                type="celebrate"
                name={orderedProduct?.name || ''}
                desc={orderedProduct?.desc || ''}
                selected={selected}
              />
            </View>
          </View>
          <VfText
            i18nKey={
              options.length === 1
                ? 'shake_buy_another_today'
                : 'shake_again_tomorrow'
            }
            size="h3"
            color={accent}
            style={styles.sectionTitle}
            loadingBackgroundColor={gradient[0]}
            loadingForegroundColor={Colors.veryLightPinkTwo}
            isLoading={loading}
          />
          <View style={styles.inlineButtons}>
            {loading ? (
              <View style={styles.leftButtonContentLoader}>
                <ContentLoader
                  speed={2}
                  width={(width - 48) / 2}
                  height={42}
                  backgroundColor={Colors.white}
                  foregroundColor={Colors.vfRed}>
                  <Rect
                    x="16"
                    y="10"
                    rx="6"
                    ry="6"
                    width={`${(width - 48) / 2 - 32}`}
                    height="22"
                  />
                </ContentLoader>
              </View>
            ) : options.length === 1 ? (
              <VFButton
                icon={images.VCoins}
                title="shake_shake_again"
                type="light"
                onPress={() => {
                  displayModal(
                    'lottie_vcoins',
                    'shake_re_shake',
                    [],
                    options[0].name,
                    [],
                    options[0].desc,
                    [],
                    'shake_button_yes_continue',
                    [],
                    () => {
                      setOrder({
                        loading: true,
                        button: 1
                      })
                      orderProduct(id || '', options[0].id || '', 'vcoins_product', {
                        onSuccess: res => {
                          setOrderedProduct(res)
                          dismissModal()
                          setScreen(SCREENS.shakeAgain)
                          setOrder({
                            loading: false,
                            button: 0
                          })
                        },
                        onError: e => {
                          if (e.reason === '405') {
                            displayError('shake_not_enough_vcoins', e.message, 'shake_button_close')
                          } else {
                            displayError('shake_button_error_general', e.message)
                          }
                          setOrder({
                            loading: false,
                            button: 0
                          })
                        }
                      })
                    },
                    'shake_button_go_back',
                    () => {
                      dismissModal()
                    },
                  )
                }}
                style={styles.leftButton}
              />
            ) : (
              <VFButton
                title="shake_back_to_dashboard"
                type="light"
                onPress={() => closeScreen()}
                style={styles.leftButton}
              />
            )}
            <VFButton
              icon={images.priceTag}
              iconColor={Colors.white}
              title="shake_zbulo_ofertat"
              type="dark"
              onPress={() => goToBundles()}
              style={styles.rightButton}
            />
          </View>
        </>
      )
    }

    return (
      <>
        <View style={styles.caruselWrapper}>
          <View style={styles.caruselContainer}>
            <Carousel
              ref={c => {
                carueselRef.current = c
              }}
              layout="stack"
              layoutCardOffset={0}
              data={cards || []}
              renderItem={({ item, index }) => <Card {...item} index={index} selected={selected} theme={theme} />}
              sliderWidth={width}
              itemWidth={width}
              itemHeight={288}
              style={styles.caruselContent}
              contentContainerCustomStyle={styles.caruselContent}
              onSnapToItem={index => onCarouselItemChange(index)}
              initialNumToRender={3}
              scrollInterpolator={stackScrollInterpolator}
              slideInterpolatedStyle={stackAnimatedStyles}
            />
            {cards.length > 1 && (
              <Pagination
                dotsLength={cards.length}
                activeDotIndex={selected}
                containerStyle={styles.paginationContainer}
                dotStyle={styles.paginationDot}
                inactiveDotOpacity={0.4}
                inactiveDotScale={1}
                tappableDots
                carouselRef={carueselRef}
              />
            )}
          </View>
        </View>
        <VfText
          i18nKey="shake_choose_gift"
          size="h3"
          color={accent}
          style={styles.sectionTitle}
        />
        <SelectGroup
          options={options}
          selected={selected}
          setSelected={select}
          style={styles.sectionGroup}
          isLoading={false}
        />
        <AnimatedButton
          visible={selected > -1}
          title={
            options[selected]?.type === 'quote'
              ? 'shake_button_continue'
              : options[selected]?.type === 'promo'
                ? 'shake_button_buy'
                : 'shake_button_redeem'
          }
          type={"primary"}
          onPress={() => {
            const selectedOption = options[selected] ?? {}
            const { recomendedProduct } = selectedOption
            if (selectedOption.type === 'quote') {
              setQuote(options[selected]?.desc)
              setLoading(true)
              getProducts?.('vcoins_product', {
                onSuccess: () => {
                  setLoading(false)
                },
                onError: () => {
                  //displayError('shake_button_error_general', e.message)
                  setLoading(false)
                }
              })
              setScreen(SCREENS.quote)
            } else if (!recomendedProduct?.id) {
              displayModal(
                'lottie_data',
                '',
                [],
                selectedOption.type === 'promo' ? 'shake_you_selected_promo' : 'shake_you_selected',
                [selectedOption.name, selectedOption.price, selectedOption.unit],
                selectedOption.productValidity,
                [],
                'shake_button_continue',
                [],
                () => {
                  setOrder({
                    loading: true,
                    button: 1
                  })
                  orderProduct(id, selectedOption.id, selectedOption.type, {
                    onSuccess: res => {
                      setOrderedProduct(res)
                      dismissModal()
                      setLoading(true)
                      getProducts?.('vcoins_product', {
                        onSuccess: () => {
                          setLoading(false)
                        },
                        onError: () => {
                          //displayError('shake_button_error_general', e.message)
                          setLoading(false)
                        }
                      })
                      setScreen(SCREENS.shakeWithVcoins)
                      setOrder({
                        loading: false,
                        button: 0
                      })
                    },
                    onError: e => {
                      if (e.reason === '403') {
                        setOrder({
                          loading: false,
                          button: 0
                        })
                        displayModal(
                          'lottie_vcoins',
                          '',
                          [],
                          'shake_no_credit',
                          [],
                          e.message,
                          [],
                          'shake_button_yes_continue',
                          [],
                          () => {
                            setOrder({
                              loading: true,
                              button: 1
                            })
                            orderProduct(id, selectedOption.id, 'loan', {
                              onSuccess: res => {
                                setOrderedProduct(res)
                                dismissModal()
                                setLoading(true)
                                getProducts?.('vcoins_product', {
                                  onSuccess: () => {
                                    setLoading(false)
                                  },
                                  onError: () => {
                                    //displayError('shake_button_error_general', err.message)
                                    setLoading(false)
                                  }
                                })
                                setScreen(SCREENS.shakeWithVcoins)
                                setOrder({
                                  loading: false,
                                  button: 0
                                })
                              },
                              onError: err => {
                                if (err.reason === '406') {
                                  displayError(
                                    'shake_loan_limit',
                                    err.message,
                                  )
                                } else {
                                  displayError(
                                    'shake_button_error_general',
                                    err.message,
                                  )
                                }
                                setOrder({
                                  loading: false,
                                  button: 0
                                })
                              }
                            })
                          },
                          'shake_button_go_back',
                          () => {
                            dismissModal()
                          },
                        )
                      } else if (e.reason === '407') {
                        setOrder({
                          loading: false,
                          button: 0
                        })
                        displayModal(
                          'lottie_vcoins',
                          '',
                          [],
                          'shake_no_credit',
                          [],
                          e.message,
                          [],
                          'shake_button_yes_continue',
                          [],
                          () => {
                            setOrder({
                              loading: true,
                              button: 1
                            })
                            orderProduct(id, selectedOption.id, 'bill', {
                              onSuccess: res => {
                                setOrderedProduct(res)
                                dismissModal()
                                setLoading(true)
                                getProducts?.('vcoins_product', {
                                  onSuccess: () => {
                                    setLoading(false)
                                  },
                                  onError: () => {
                                    //displayError('shake_button_error_general', err.message)
                                    setLoading(false)
                                  }
                                })
                                setScreen(SCREENS.shakeWithVcoins)
                                setOrder({
                                  loading: false,
                                  button: 0
                                })
                              },
                              onError: err => {
                                if (err.reason === '406') {
                                  displayError(
                                    'shake_loan_limit',
                                    err.message,
                                  )
                                } else {
                                  displayError(
                                    'shake_button_error_general',
                                    err.message,
                                  )
                                }
                                setOrder({
                                  loading: false,
                                  button: 0
                                })
                              }
                            })
                          },
                          'shake_button_go_back',
                          () => {
                            dismissModal()
                          },
                        )
                      } else {
                        displayError('shake_button_error_general', e.message)
                        setOrder({
                          loading: false,
                          button: 0
                        })
                      }
                    }
                  })
                },
                'shake_button_go_back',
                () => {
                  dismissModal()
                },
              )
            } else {
              displayModal(
                'lottie_data',
                'shake_free_gift',
                [selectedOption.title],
                recomendedProduct.title,
                [],
                recomendedProduct.desc,
                [],
                'shake_button_upgrade_gift',
                [(recomendedProduct.price || ''), recomendedProduct.unit],
                () => {
                  setOrder({
                    loading: true,
                    button: 1
                  })
                  orderProduct(id, recomendedProduct.id, recomendedProduct.type, {
                    onSuccess: res => {
                      setOrderedProduct(res)
                      dismissModal()
                      setLoading(true)
                      getProducts?.('vcoins_product', {
                        onSuccess: () => {
                          setLoading(false)
                        },
                        onError: () => {
                          //displayError('shake_button_error_general', e.message)
                          setLoading(false)
                        }
                      })
                      setScreen(SCREENS.shakeWithVcoins)
                      setOrder({
                        loading: false,
                        button: 0
                      })
                    },
                    onError: e => {
                      if (e.reason === '403') {
                        setOrder({
                          loading: false,
                          button: 0
                        })
                        displayModal(
                          'lottie_vcoins',
                          '',
                          [],
                          'shake_no_credit',
                          [],
                          e.message,
                          [],
                          'shake_button_yes_continue',
                          [],
                          () => {
                            setOrder({
                              loading: true,
                              button: 1
                            })
                            orderProduct(id, recomendedProduct.id, 'loan', {
                              onSuccess: res => {
                                setOrderedProduct(res)
                                dismissModal()
                                setLoading(true)
                                getProducts?.('vcoins_product', {
                                  onSuccess: () => {
                                    setLoading(false)
                                  },
                                  onError: () => {
                                    // displayError(
                                    //   'shake_button_error_general',
                                    //   err.message,
                                    // )
                                    setLoading(false)
                                  }
                                })
                                setScreen(SCREENS.shakeWithVcoins)
                                setOrder({
                                  loading: false,
                                  button: 0
                                })
                              },
                              onError: err => {
                                if (err.reason === '406') {
                                  displayError(
                                    'shake_loan_limit',
                                    err.message,
                                  )
                                } else {
                                  displayError(
                                    'shake_button_error_general',
                                    err.message,
                                  )
                                }
                                setOrder({
                                  loading: false,
                                  button: 0
                                })
                              }
                            })
                          },
                          'shake_button_go_back',
                          () => {
                            dismissModal()
                          },
                        )
                      } else if (e.reason === '407') {
                        setOrder({
                          loading: false,
                          button: 0
                        })
                        displayModal(
                          'lottie_vcoins',
                          '',
                          [],
                          'shake_no_credit',
                          [],
                          e.message,
                          [],
                          'shake_button_yes_continue',
                          [],
                          () => {
                            setOrder({
                              loading: true,
                              button: 1
                            })
                            orderProduct(id, recomendedProduct.id, 'bill', {
                              onSuccess: res => {
                                setOrderedProduct(res)
                                dismissModal()
                                setLoading(true)
                                getProducts?.('vcoins_product', {
                                  onSuccess: () => {
                                    setLoading(false)
                                  },
                                  onError: () => {
                                    // displayError(
                                    //   'shake_button_error_general',
                                    //   err.message,
                                    // )
                                    setLoading(false)
                                  }
                                })
                                setScreen(SCREENS.shakeWithVcoins)
                                setOrder({
                                  loading: false,
                                  button: 0
                                })
                              },
                              onError: err => {
                                if (err.reason === '406') {
                                  displayError(
                                    'shake_loan_limit',
                                    err.message,
                                  )
                                } else {
                                  displayError(
                                    'shake_button_error_general',
                                    err.message,
                                  )
                                }
                                setOrder({
                                  loading: false,
                                  button: 0
                                })
                              }
                            })
                          },
                          'shake_button_go_back',
                          () => {
                            dismissModal()
                          },
                        )
                      } else {
                        displayError('shake_button_error_general', e.message)
                        setOrder({
                          loading: false,
                          button: 0
                        })
                      }
                    }
                  })
                },
                'shake_button_continue_free',
                () => {
                  setOrder({
                    loading: true,
                    button: 2
                  })
                  orderProduct(id, selectedOption.id, selectedOption.type, {
                    onSuccess: res => {
                      setOrderedProduct(res)
                      dismissModal()
                      setLoading(true)
                      getProducts?.('vcoins_product', {
                        onSuccess: () => {
                          setLoading(false)
                        },
                        onError: () => {
                          //displayError('shake_button_error_general', e.message)
                          setLoading(false)
                        }
                      })
                      setScreen(SCREENS.shakeWithVcoins)
                      setOrder({
                        loading: false,
                        button: 0
                      })
                    },
                    onError: e => {
                      displayError('shake_button_error_general', e.message)
                      setOrder({
                        loading: false,
                        button: 0
                      })
                    }
                  })
                },
              )
            }
          }}
          style={styles.button}
        />
      </>
    )
  }

  // const changeStatusBar = (
  //   barStyle = 'light-content',
  //   backgroundColor = Colors.transparent,
  //   translucent = true,
  // ) => {
  //   StatusBar.setBarStyle(barStyle, true)
  //   if (Platform.OS === 'android') {
  //     StatusBar.setBackgroundColor(backgroundColor, true)
  //     StatusBar.setTranslucent(translucent)
  //   }
  // }

  // const resetStatusBar = () => {
  //   changeStatusBar(Platform.OS === 'android' ? 'light-content' : 'dark-content', Colors.thinDark, false)
  // }

  const closeScreen = () => {
    // resetStatusBar()
    onClose()
  }

  const goToBundles = () => {
    //resetStatusBar()
    navigateToBundles()
  }

  useEffect(() => {
    const backAction = () => {
      // resetStatusBar()
      return false
    }
    const backHandler = BackHandler.addEventListener(
      'hardwareBackPress',
      backAction
    )
    return () => backHandler.remove()
  }, [])

  const renderShakeContentWeb = () => {
    if (screen === SCREENS.shaking) {
      return (
        <ShakeAnim
          onShake={getProducts}
          setLoading={setLoading}
          displayOffers={() => setScreen(SCREENS.gift)}
          showLimitReached={() => setScreen(SCREENS.limitReached)}
          displayError={message =>
            displayError(
              'shake_button_error_general',
              message || '',
              'shake_button_try_again',
              () => dismissError(),
              '',
              null,
            )
          }
          textColor={accent}
        />
      )
    }
    if (screen === SCREENS.quote) {
      return (
        <>
          <View style={styles.caruselWrapper}>
            <View style={styles.caruselContainer}>
              <Card
                index={0}
                type="chat"
                name="Quote"
                desc={quote}
                selected={selected}
              />
            </View>
          </View>
          <View style={styles.sectionTitle}>
            <VfText
              i18nKey={
                options.length === 1
                  ? 'shake_another_left_today'
                  : 'shake_again_tomorrow'
              }
              size="h3"
              color={accent}
              loadingBackgroundColor={gradient[0]}
              loadingForegroundColor={accent}
              isLoading={loading}
            />
          </View>
          <View style={styles.inlineButtons}>
            {loading ? (
              <View style={styles.leftButtonContentLoader}>
                <ContentLoader
                  speed={2}
                  width={(width - 48) / 2}
                  height={42}
                  backgroundColor={Colors.white}
                  foregroundColor={Colors.vfRed}>
                  <Rect
                    x="16"
                    y="10"
                    rx="6"
                    ry="6"
                    width={`${(width - 48) / 2 - 32}`}
                    height="22"
                  />
                </ContentLoader>
              </View>
            ) : options.length === 1 ? (
              <VFButton
                icon={images.VCoins}
                title="shake_shake_again"
                type="light"
                onPress={() => {
                  displayModal(
                    'lottie_vcoins',
                    'shake_re_shake',
                    [],
                    options[0].name,
                    [],
                    options[0].desc,
                    [],
                    'shake_button_yes_continue',
                    [],
                    () => {
                      setOrder({
                        loading: true,
                        button: 1
                      })
                      orderProduct(id || '', options[0].id || '', 'vcoins_product', {
                        onSuccess: res => {
                          setOrderedProduct(res)
                          dismissModal()
                          setScreen(SCREENS.shakeAgain)
                          setOrder({
                            loading: false,
                            button: 0
                          })
                        },
                        onError: e => {
                          if (e.reason === '405') {
                            displayError('shake_not_enough_vcoins', e.message, 'shake_button_close')
                          } else {
                            displayError('shake_button_error_general', e.message)
                          }
                          setOrder({
                            loading: false,
                            button: 0
                          })
                        }
                      })
                    },
                    'shake_button_go_back',
                    () => {
                      dismissModal()
                    },
                  )
                }}
                style={styles.leftButton}
              />
            ) : (
              <VFButton
                title="shake_back_to_dashboard"
                type="light"
                onPress={() => closeScreen()}
                style={styles.leftButton}
              />
            )}
            <VFButton
              icon={images.priceTag}
              iconColor={Colors.white}
              title="shake_zbulo_ofertat"
              type="dark"
              onPress={() => goToBundles()}
              style={styles.rightButton}
            />
          </View>
        </>
      )
    }

    if (screen === SCREENS.limitReached) {
      return (
        <>
          <View style={styles.caruselWrapper}>
            <View style={styles.caruselContainer}>
              <Card
                index={0}
                type="bundles"
                name="shake_explore_offers_title"
                desc="shake_explore_offers_desc"
                selected={selected}
              />
            </View>
          </View>
          <VfText
            i18nKey={
              options.length === 1
                ? 'shake_buy_another_today'
                : 'shake_again_tomorrow'
            }
            size="h3"
            color={accent}
            style={styles.sectionTitle}
            loadingBackgroundColor={gradient[0]}
            loadingForegroundColor={Colors.veryLightPinkTwo}
            isLoading={loading}
          />
          <View style={styles.inlineButtons}>
            {loading
              ? (
                <View style={styles.leftButtonContentLoader}>
                  <ContentLoader
                    speed={2}
                    width={Platform.OS === 'web' && Dimensions.get('window').width > 700 ? `${(width - 300) * 0.36}` : `${(width - 48) / 2 - 32}`}
                    height={42}
                    backgroundColor={Colors.white}
                    foregroundColor={Colors.vfRed}>
                    <Rect
                      x="16"
                      y="10"
                      rx="6"
                      ry="6"
                      width={Platform.OS === 'web' && Dimensions.get('window').width > 700 ? `${(width - 300) * 0.36}` : `${(width - 48) / 2 - 32}`}
                      height="22"
                    />
                  </ContentLoader>
                </View>
              )
              : options.length === 1
                ? (
                  <VFButton
                    icon={images.VCoins}
                    title="shake_shake_again"
                    type="light"
                    onPress={() => {
                      displayModal(
                        'lottie_vcoins',
                        'shake_re_shake',
                        [],
                        options[0].name,
                        [],
                        options[0].desc,
                        [],
                        'shake_button_yes_continue',
                        [],
                        () => {
                          setOrder({
                            loading: true,
                            button: 1
                          })
                          orderProduct(id || '', options[0].id || '', 'vcoins_product', {
                            onSuccess: res => {
                              setOrderedProduct(res)
                              dismissModal()
                              setScreen(SCREENS.shakeAgain)
                              setOrder({
                                loading: false,
                                button: 0
                              })
                            },
                            onError: e => {
                              if (e.reason === '405') {
                                displayError('shake_not_enough_vcoins', e.message, 'shake_button_close')
                              } else {
                                displayError('shake_button_error_general', e.message)
                              }
                              setOrder({
                                loading: false,
                                button: 0
                              })
                            }
                          })
                        },
                        'shake_button_go_back',
                        () => {
                          dismissModal()
                        },
                      )
                    }}
                    style={styles.leftButton}
                  />
                )
                : (
                  <VFButton
                    title="shake_back_to_dashboard"
                    type="light"
                    onPress={() => closeScreen()}
                    style={styles.leftButton}
                  />
                )}
            <VFButton
              icon={images.priceTag}
              iconColor={Colors.white}
              title="shake_zbulo_ofertat"
              type="dark"
              onPress={() => goToBundles()}
              style={styles.rightButton}
            />
          </View>
        </>
      )
    }

    if (screen === SCREENS.shakeAgain) {
      return (
        <>
          <View style={styles.caruselWrapper}>
            <View style={styles.caruselContainer}>
              <Card
                index={0}
                type="bundles"
                name={orderedProduct?.name}
                desc={orderedProduct?.desc}
                selected={selected}
              />
            </View>
          </View>
          <VfText
            i18nKey="shake_another_left_today"
            size="h3"
            color={accent}
            style={styles.sectionTitle}
            loadingBackgroundColor={Colors.white}
            loadingForegroundColor={Colors.veryLightPinkTwo}
            isLoading={loading}
          />
          <View style={styles.inlineButtons}>
            <VFButton
              title="shake_try_now"
              type="light"
              onPress={() => setScreen(SCREENS.shaking)}
              style={styles.leftButton}
            />
            <VFButton
              title="shake_later_today"
              type="dark"
              onPress={() => closeScreen()}
              style={styles.rightButton}
            />
          </View>
        </>
      )
    }

    if (screen === SCREENS.shakeWithVcoins) {
      return (
        <>
          <View style={styles.caruselWrapper}>
            <View style={styles.caruselContainer}>
              <Card
                index={0}
                type="celebrate"
                name={orderedProduct?.name || ''}
                desc={orderedProduct?.desc || ''}
                selected={selected}
              />
            </View>
          </View>
          <VfText
            i18nKey={
              options.length === 1
                ? 'shake_buy_another_today'
                : 'shake_again_tomorrow'
            }
            size="h3"
            color={accent}
            style={styles.sectionTitle}
            loadingBackgroundColor={gradient[0]}
            loadingForegroundColor={Colors.veryLightPinkTwo}
            isLoading={loading}
          />
          <View style={styles.inlineButtons}>
            {loading ? (
              <View style={styles.leftButtonContentLoader}>
                <ContentLoader
                  speed={2}
                  width={(width - 48) / 2}
                  height={42}
                  backgroundColor={Colors.white}
                  foregroundColor={Colors.vfRed}>
                  <Rect
                    x="16"
                    y="10"
                    rx="6"
                    ry="6"
                    width={`${(width - 48) / 2 - 32}`}
                    height="22"
                  />
                </ContentLoader>
              </View>
            ) : options.length === 1 ? (
              <VFButton
                icon={images.VCoins}
                title="shake_shake_again"
                type="light"
                onPress={() => {
                  displayModal(
                    'lottie_vcoins',
                    'shake_re_shake',
                    [],
                    options[0].name,
                    [],
                    options[0].desc,
                    [],
                    'shake_button_yes_continue',
                    [],
                    () => {
                      setOrder({
                        loading: true,
                        button: 1
                      })
                      orderProduct(id || '', options[0].id || '', 'vcoins_product', {
                        onSuccess: res => {
                          setOrderedProduct(res)
                          dismissModal()
                          setScreen(SCREENS.shakeAgain)
                          setOrder({
                            loading: false,
                            button: 0
                          })
                        },
                        onError: e => {
                          if (e.reason === '405') {
                            displayError('shake_not_enough_vcoins', e.message, 'shake_button_close')
                          } else {
                            displayError('shake_button_error_general', e.message)
                          }
                          setOrder({
                            loading: false,
                            button: 0
                          })
                        }
                      })
                    },
                    'shake_button_go_back',
                    () => {
                      dismissModal()
                    },
                  )
                }}
                style={styles.leftButton}
              />
            ) : (
              <VFButton
                title="shake_back_to_dashboard"
                type="light"
                onPress={() => closeScreen()}
                style={styles.leftButton}
              />
            )}
            <VFButton
              icon={images.priceTag}
              iconColor={Colors.white}
              title="shake_zbulo_ofertat"
              type="dark"
              onPress={() => goToBundles()}
              style={styles.rightButton}
            />
          </View>
        </>
      )
    }

    return (
      <>
        <View style={styles.caruselWrapper}>
          <View style={styles.caruselContainer}>
            <Carousel
              ref={c => {
                carueselRef.current = c
              }}
              layout="stack"
              layoutCardOffset={0}
              data={cards || []}
              renderItem={({ item, index }) => <Card {...item} index={index} selected={selected} theme={theme} />}
              sliderWidth={(width - 300) * 0.8}
              itemWidth={(width - 300) * 0.8}
              itemHeight={288}
              style={styles.caruselContent}
              contentContainerCustomStyle={styles.caruselContent}
              onSnapToItem={index => onCarouselItemChange(index)}
              initialNumToRender={3}
              scrollInterpolator={stackScrollInterpolator}
              slideInterpolatedStyle={stackAnimatedStyles}
            />
            {cards.length > 1 && (
              <Pagination
                dotsLength={cards.length}
                activeDotIndex={selected}
                containerStyle={styles.paginationContainer}
                dotStyle={styles.paginationDot}
                inactiveDotOpacity={0.4}
                inactiveDotScale={1}
                tappableDots
                carouselRef={carueselRef}
              />
            )}
          </View>
        </View>

        <SelectGroup
          options={options}
          selected={selected}
          setSelected={select}
          style={styles.sectionGroup}
          isLoading={false}
        />
        <AnimatedButton
          visible={selected > -1}
          title={
            options[selected]?.type === 'quote'
              ? 'shake_button_continue'
              : options[selected]?.type === 'promo'
                ? 'shake_button_buy'
                : 'shake_button_redeem'
          }
          type={'primary'}
          onPress={() => {
            const selectedOption = options[selected] ?? {}
            const { recomendedProduct } = selectedOption
            if (selectedOption.type === 'quote') {
              setQuote(options[selected]?.desc)
              setLoading(true)
              getProducts?.('vcoins_product', {
                onSuccess: () => {
                  setLoading(false)
                },
                onError: () => {
                  //displayError('shake_button_error_general', e.message)
                  setLoading(false)
                }
              })
              setScreen(SCREENS.quote)
            } else if (!recomendedProduct?.id) {
              displayModal(
                'lottie_data',
                '',
                [],
                selectedOption.type === 'promo' ? 'shake_you_selected_promo' : 'shake_you_selected',
                [selectedOption.name, selectedOption.price, selectedOption.unit],
                selectedOption.productValidity,
                [],
                'shake_button_continue',
                [],
                () => {
                  setOrder({
                    loading: true,
                    button: 1
                  })
                  orderProduct(id, selectedOption.id, selectedOption.type, {
                    onSuccess: res => {
                      setOrderedProduct(res)
                      dismissModal()
                      setLoading(true)
                      getProducts?.('vcoins_product', {
                        onSuccess: () => {
                          setLoading(false)
                        },
                        onError: () => {
                          //displayError('shake_button_error_general', e.message)
                          setLoading(false)
                        }
                      })
                      setScreen(SCREENS.shakeWithVcoins)
                      setOrder({
                        loading: false,
                        button: 0
                      })
                    },
                    onError: e => {
                      if (e.reason === '403') {
                        setOrder({
                          loading: false,
                          button: 0
                        })
                        displayModal(
                          'lottie_vcoins',
                          '',
                          [],
                          'shake_no_credit',
                          [],
                          e.message,
                          [],
                          'shake_button_yes_continue',
                          [],
                          () => {
                            setOrder({
                              loading: true,
                              button: 1
                            })
                            orderProduct(id, selectedOption.id, 'loan', {
                              onSuccess: res => {
                                setOrderedProduct(res)
                                dismissModal()
                                setLoading(true)
                                getProducts?.('vcoins_product', {
                                  onSuccess: () => {
                                    setLoading(false)
                                  },
                                  onError: () => {
                                    //displayError('shake_button_error_general', err.message)
                                    setLoading(false)
                                  }
                                })
                                setScreen(SCREENS.shakeWithVcoins)
                                setOrder({
                                  loading: false,
                                  button: 0
                                })
                              },
                              onError: err => {
                                if (err.reason === '406') {
                                  displayError(
                                    'shake_loan_limit',
                                    err.message,
                                  )
                                } else {
                                  displayError(
                                    'shake_button_error_general',
                                    err.message,
                                  )
                                }
                                setOrder({
                                  loading: false,
                                  button: 0
                                })
                              }
                            })
                          },
                          'shake_button_go_back',
                          () => {
                            dismissModal()
                          },
                        )
                      } else if (e.reason === '407') {
                        setOrder({
                          loading: false,
                          button: 0
                        })
                        displayModal(
                          'lottie_vcoins',
                          '',
                          [],
                          'shake_no_credit',
                          [],
                          e.message,
                          [],
                          'shake_button_yes_continue',
                          [],
                          () => {
                            setOrder({
                              loading: true,
                              button: 1
                            })
                            orderProduct(id, selectedOption.id, 'bill', {
                              onSuccess: res => {
                                setOrderedProduct(res)
                                dismissModal()
                                setLoading(true)
                                getProducts?.('vcoins_product', {
                                  onSuccess: () => {
                                    setLoading(false)
                                  },
                                  onError: () => {
                                    //displayError('shake_button_error_general', err.message)
                                    setLoading(false)
                                  }
                                })
                                setScreen(SCREENS.shakeWithVcoins)
                                setOrder({
                                  loading: false,
                                  button: 0
                                })
                              },
                              onError: err => {
                                if (err.reason === '406') {
                                  displayError(
                                    'shake_loan_limit',
                                    err.message,
                                  )
                                } else {
                                  displayError(
                                    'shake_button_error_general',
                                    err.message,
                                  )
                                }
                                setOrder({
                                  loading: false,
                                  button: 0
                                })
                              }
                            })
                          },
                          'shake_button_go_back',
                          () => {
                            dismissModal()
                          },
                        )
                      } else {
                        displayError('shake_button_error_general', e.message)
                        setOrder({
                          loading: false,
                          button: 0
                        })
                      }
                    }
                  })
                },
                'shake_button_go_back',
                () => {
                  dismissModal()
                },
              )
            } else {
              displayModal(
                'lottie_data',
                'shake_free_gift',
                [selectedOption.title],
                recomendedProduct.title,
                [],
                recomendedProduct.desc,
                [],
                'shake_button_upgrade_gift',
                [(recomendedProduct.price || '') + '', recomendedProduct.unit],
                () => {
                  setOrder({
                    loading: true,
                    button: 1
                  })
                  orderProduct(id, recomendedProduct.id, recomendedProduct.type, {
                    onSuccess: res => {
                      setOrderedProduct(res)
                      dismissModal()
                      setLoading(true)
                      getProducts?.('vcoins_product', {
                        onSuccess: () => {
                          setLoading(false)
                        },
                        onError: () => {
                          //displayError('shake_button_error_general', e.message)
                          setLoading(false)
                        }
                      })
                      setScreen(SCREENS.shakeWithVcoins)
                      setOrder({
                        loading: false,
                        button: 0
                      })
                    },
                    onError: e => {
                      if (e.reason === '403') {
                        setOrder({
                          loading: false,
                          button: 0
                        })
                        displayModal(
                          'lottie_vcoins',
                          '',
                          [],
                          'shake_no_credit',
                          [],
                          e.message,
                          [],
                          'shake_button_yes_continue',
                          [],
                          () => {
                            setOrder({
                              loading: true,
                              button: 1
                            })
                            orderProduct(id, recomendedProduct.id, 'loan', {
                              onSuccess: res => {
                                setOrderedProduct(res)
                                dismissModal()
                                setLoading(true)
                                getProducts?.('vcoins_product', {
                                  onSuccess: () => {
                                    setLoading(false)
                                  },
                                  onError: () => {
                                    // displayError(
                                    //   'shake_button_error_general',
                                    //   err.message,
                                    // )
                                    setLoading(false)
                                  }
                                })
                                setScreen(SCREENS.shakeWithVcoins)
                                setOrder({
                                  loading: false,
                                  button: 0
                                })
                              },
                              onError: err => {
                                if (err.reason === '406') {
                                  displayError(
                                    'shake_loan_limit',
                                    err.message,
                                  )
                                } else {
                                  displayError(
                                    'shake_button_error_general',
                                    err.message,
                                  )
                                }
                                setOrder({
                                  loading: false,
                                  button: 0
                                })
                              }
                            })
                          },
                          'shake_button_go_back',
                          () => {
                            dismissModal()
                          },
                        )
                      } else if (e.reason === '407') {
                        setOrder({
                          loading: false,
                          button: 0
                        })
                        displayModal(
                          'lottie_vcoins',
                          '',
                          [],
                          'shake_no_credit',
                          [],
                          e.message,
                          [],
                          'shake_button_yes_continue',
                          [],
                          () => {
                            setOrder({
                              loading: true,
                              button: 1
                            })
                            orderProduct(id, recomendedProduct.id, 'bill', {
                              onSuccess: res => {
                                setOrderedProduct(res)
                                dismissModal()
                                setLoading(true)
                                getProducts?.('vcoins_product', {
                                  onSuccess: () => {
                                    setLoading(false)
                                  },
                                  onError: () => {
                                    // displayError(
                                    //   'shake_button_error_general',
                                    //   err.message,
                                    // )
                                    setLoading(false)
                                  }
                                })
                                setScreen(SCREENS.shakeWithVcoins)
                                setOrder({
                                  loading: false,
                                  button: 0
                                })
                              },
                              onError: err => {
                                if (err.reason === '406') {
                                  displayError(
                                    'shake_loan_limit',
                                    err.message,
                                  )
                                } else {
                                  displayError(
                                    'shake_button_error_general',
                                    err.message,
                                  )
                                }
                                setOrder({
                                  loading: false,
                                  button: 0
                                })
                              }
                            })
                          },
                          'shake_button_go_back',
                          () => {
                            dismissModal()
                          },
                        )
                      } else {
                        displayError('shake_button_error_general', e.message)
                        setOrder({
                          loading: false,
                          button: 0
                        })
                      }
                    }
                  })
                },
                'shake_button_continue_free',
                () => {
                  setOrder({
                    loading: true,
                    button: 2
                  })
                  orderProduct(id, selectedOption.id, selectedOption.type, {
                    onSuccess: res => {
                      setOrderedProduct(res)
                      dismissModal()
                      setLoading(true)
                      getProducts?.('vcoins_product', {
                        onSuccess: () => {
                          setLoading(false)
                        },
                        onError: () => {
                          //displayError('shake_button_error_general', e.message)
                          setLoading(false)
                        }
                      })
                      setScreen(SCREENS.shakeWithVcoins)
                      setOrder({
                        loading: false,
                        button: 0
                      })
                    },
                    onError: e => {
                      displayError('shake_button_error_general', e.message)
                      setOrder({
                        loading: false,
                        button: 0
                      })
                    }
                  })
                },
              )
            }
          }}
          style={styles.button}
        />
      </>
    )
  }

  const renderModals = () => {
    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      return (
        <>
          <_Modal
            isVisible={details.isVisible}
            backdropOpacity={0.5}
            onSwipeComplete={() => setDetails(prev => ({ ...prev, isVisible: false }))}
            onBackdropPress={() => setDetails(prev => ({ ...prev, isVisible: false }))}
            propagateSwipe
            hideModalContentWhileAnimating
            hardwareAccelerated
            backdropTransitionOutTiming={0}
            style={{
              justifyContent: 'flex-end',
              margin: '0 !important',
              minWidth: 1920,
              maxWidth: 1920,
            }}
          >
            <View
              style={{
                minWidth: '600px',
                maxWidth: '600px',
                height: 'auto',
                backgroundColor: themeColors.colors.quickActionGradientColors.secondary,
                margin: 'auto',
                padding: '20px',
                paddingTop: null,
                borderRadius: "7px",
              }}
              onStartShouldSetResponder={() => true}>
              <View style={[styles.detailsContent, { padding: 0 }]}>
                <VfText
                  size="h5"
                  weight="bold"
                  isLoading={isContentLoading}
                  i18nKey="shake_modal_header_info"
                  color={themeColors.colors.textColor}
                />
                <TouchableOpacity onPress={() => dismissDetails()}>
                  <Icon
                    source={images.close}
                    size={20}
                    type="image"
                    resizeMode="contain"
                    style={{
                      tintColor: Colors.thinDark
                    }}
                  />
                </TouchableOpacity>
              </View>
              <View
                style={{ height: height * 7 / 10, color: 'white' }}
                onStartShouldSetResponder={() => true}>
                <WebView
                  source={{ uri: 'https://api-web-ci-vfal.vodafone.com/file/shake/more_info/Shake_Info_AL.html' }}
                  style={styles.webView}
                  startInLoadingState={true}
                  renderLoading={() => (
                    <View style={styles.lottieWrapper}>
                      <MigrationLottie
                        source={require('./loaderE60000.json')}
                        style={styles.lottie}
                      />
                    </View>
                  )}
                />
              </View>
            </View>
          </_Modal>
          <_Modal
            isVisible={modal.isVisible}
            backdropOpacity={0.5}
            onSwipeComplete={() => setModal(prev => ({ ...prev, isVisible: false }))}
            onBackdropPress={() => setModal(prev => ({ ...prev, isVisible: false }))}
            propagateSwipe
            hideModalContentWhileAnimating
            hardwareAccelerated
            backdropTransitionOutTiming={0}
            style={{
              justifyContent: 'flex-end',
              margin: '0 !important',
              minWidth: 1920,
              maxWidth: 1920,
            }}
          >
            <View
              style={{
                minWidth: '600px',
                maxWidth: '600px',
                height: 'auto',
                backgroundColor: themeColors.colors.quickActionGradientColors.secondary,
                margin: 'auto',
                padding: '20px',
                paddingTop: null,
                borderRadius: "7px",
              }}
              onStartShouldSetResponder={() => true}>
              <View style={[styles.headerContentWrapper(insets.top), { margin: 0, marginTop: 20 }]}>
                <View style={styles.empty} />
                <VfText i18nKey={modal.header} size="h4" color={themeColors.colors.textColor} />
                <TouchableOpacity onPress={() => dismissModal()}>
                  <Icon
                    name={images.close}
                    type="image"
                    resizeMode="contain"
                    size={24}
                    style={{ tintColor: themeColors.colors.textColor }}
                  />
                </TouchableOpacity>
              </View>
              <View style={[styles.modalContentContainerWraper(insets.bottom, themeColors), { paddingHorizontal: 0, paddingTop: 32 }]}>
                <View style={styles.modalContentWraper}>
                  {modal.selectedPlaceHolders.length > 0 && (
                    <VfText
                      weight="bold"
                      align="center"
                      size="h4"
                      isLoading={isContentLoading}
                      i18nKey="shake_you_selected"
                      placeHolders={modal.selectedPlaceHolders}
                      color={themeColors.colors.textColor}
                    />
                  )}
                  <View style={styles.modalAnimIconContainer}>
                    {animations.includes(modal.icon) && (
                      <LottieView
                        source={images[modal.icon]}
                        autoPlay={true}
                        loop={true}
                        resizeMode="cover"
                        imageAssetsFolder={'../../Images/lottieIcons'}
                        style={styles.modalAnimIcon}
                      />
                    )}
                  </View>
                  <View>
                    <VfText
                      weight="bold"
                      size="h3"
                      align="center"
                      style={styles.verticalSpacing}
                      isLoading={isContentLoading}
                      i18nKey={modal.title}
                      placeHolders={modal.titlePlaceHolders}
                      color={themeColors.colors.textColor}
                    />
                    <VfText
                      align="center"
                      isLoading={isContentLoading}
                      i18nKey={modal.desc}
                      placeHolders={modal.descPlaceHolders}
                      color={themeColors.colors.textColor}
                    />
                  </View>
                </View>
                <VFButton
                  type="primary"
                  title={modal.primaryLabel || 'shake_button_go_back'}
                  placeHolders={modal.primaryPlaceHolders}
                  onPress={() => modal.primaryAction?.()}
                  style={
                    modal.secondaryAction
                      ? styles.modalButton
                      : styles.lastModalButton
                  }
                  disabled={order.loading}
                  isLoading={order.loading && order.button === 1}
                  loadingTitle={'Processing...'}
                />
                {modal.secondaryAction && (
                  <VFButton
                    type={order.loading ? 'primary' : 'secondary'}
                    title={modal.secondaryLabel || 'shake_button_close'}
                    onPress={() => modal.secondaryAction()}
                    disabled={order.loading}
                    isLoading={order.loading && order.button === 2}
                    loadingTitle={'Processing...'}
                  />
                )}
              </View>
            </View>
          </_Modal>
          <_Modal
            isVisible={error.isVisible}
            backdropOpacity={0.5}
            onSwipeComplete={() => setError(prev => ({ ...prev, isVisible: false }))}
            onBackdropPress={() => setError(prev => ({ ...prev, isVisible: false }))}
            propagateSwipe
            hideModalContentWhileAnimating
            hardwareAccelerated
            backdropTransitionOutTiming={0}
            style={{
              justifyContent: 'flex-end',
              margin: '0 !important',
              minWidth: 1920,
              maxWidth: 1920,
            }}
          >
            <View
              style={{
                minWidth: '600px',
                maxWidth: '600px',
                height: 'auto',
                backgroundColor: themeColors.colors.quickActionGradientColors.secondary,
                margin: 'auto',
                padding: '20px',
                paddingTop: null,
                borderRadius: "7px",
              }}
              onStartShouldSetResponder={() => true}>
              <View style={styles.modalContentContainerWraper(insets.bottom, themeColors)}>
                <View style={styles.modalContentWraper}>
                  <Icon
                    name={images.warning}
                    size={48}
                    type="image"
                    resizeMode="contain"
                  />
                  <VfText
                    weight="bold"
                    size="h3"
                    align="center"
                    style={styles.verticalSpacing}
                    isLoading={isContentLoading}
                    i18nKey={error.title}
                    color={themeColors.colors.textColor}
                  />
                  <VfText
                    align="center"
                    isLoading={isContentLoading}
                    i18nKey={error.desc}
                    color={themeColors.colors.textColor}
                  />
                </View>
                <VFButton
                  type="primary"
                  title={error.primaryLabel || 'shake_button_go_back'}
                  onPress={() => error.primaryAction?.()}
                  style={
                    error.secondaryAction
                      ? styles.modalButton
                      : styles.lastModalButton
                  }
                />
                {error.secondaryAction && (
                  <VFButton
                    type="secondary"
                    title={error.secondaryLabel || ''}
                    onPress={() => error.secondaryAction()}
                    style={styles.lastModalButton}
                  />
                )}
              </View>
            </View>
          </_Modal>
        </>
      )
    } else {
      return (
        <>
          <Modal
            visible={details.isVisible}
            close={() => dismissDetails()}
            onModalHide={() => details.onHide?.()}
            contentContainerStyle={styles.modal}
            insets={insets}>
            <View style={styles.detailsContent}>
              <VfText
                size="h5"
                weight="bold"
                isLoading={isContentLoading}
                i18nKey="shake_modal_header_info"
              />
              <TouchableOpacity onPress={() => dismissDetails()}>
                <Icon
                  source={images.close}
                  size={20}
                  type="image"
                  resizeMode="contain"
                  style={{
                    tintColor: Colors.thinDark
                  }}
                />
              </TouchableOpacity>
            </View>
            <View
              style={{ height: height * 7 / 10 }}
              onStartShouldSetResponder={() => true}>
              <WebView
                source={{ uri: ContentManager.translate('shake_url_info') }}
                style={styles.webView}
                startInLoadingState={true}
                renderLoading={() => (
                  <View style={styles.lottieWrapper}>
                    <MigrationLottie
                      source={require('./loaderE60000.json')}
                      style={styles.lottie}
                    />
                  </View>
                )}
              />
            </View>
          </Modal>
          <Modal
            visible={modal.isVisible}
            contentContainerStyle={{ backgroundColor: themeColors.colors.backgroundColor }}
            close={() => dismissModal()}
            onModalHide={() => modal.onHide?.()}
            type="full">
            <View style={styles.headerContentWrapper(insets.top)}>
              <View style={styles.empty} />
              <VfText i18nKey={modal.header} size="h4" color={themeColors.colors.textColor} />
              <TouchableOpacity onPress={() => dismissModal()}>
                <Icon
                  name={images.close}
                  style={{ tintColor: themeColors.colors.textColor }}
                  type="image"
                  resizeMode="contain"
                  size={24}
                />
              </TouchableOpacity>
            </View>
            <View style={styles.modalContentContainerWraper(insets.bottom, themeColors)}>
              <View style={styles.modalContentWraper}>
                {modal.selectedPlaceHolders.length > 0 && (
                  <VfText
                    weight="bold"
                    align="center"
                    size="h4"
                    isLoading={isContentLoading}
                    i18nKey="shake_you_selected"
                    color={themeColors.colors.textColor}
                    placeHolders={modal.selectedPlaceHolders}
                  />
                )}
                <View style={styles.modalAnimIconContainer}>
                  {animations.includes(modal.icon) && (
                    <LottieView
                      source={images[modal.icon]}
                      autoPlay={true}
                      loop={true}
                      resizeMode="cover"
                      imageAssetsFolder={'../../Images/lottieIcons'}
                      style={styles.modalAnimIcon}
                    />
                  )}
                </View>
                <View>
                  <VfText
                    weight="bold"
                    size="h3"
                    align="center"
                    style={styles.verticalSpacing}
                    isLoading={isContentLoading}
                    i18nKey={modal.title}
                    placeHolders={modal.titlePlaceHolders}
                    color={themeColors.colors.textColor}
                  />
                  <VfText
                    align="center"
                    isLoading={isContentLoading}
                    i18nKey={modal.desc}
                    placeHolders={modal.descPlaceHolders}
                    color={themeColors.colors.textColor}
                  />
                </View>
              </View>
              <VFButton
                type="primary"
                title={modal.primaryLabel || 'shake_button_go_back'}
                placeHolders={modal.primaryPlaceHolders}
                onPress={() => modal.primaryAction?.()}
                style={
                  modal.secondaryAction
                    ? styles.modalButton
                    : styles.lastModalButton
                }
                disabled={order.loading}
                isLoading={order.loading && order.button === 1}
                loadingTitle={'Processing...'}
              />
              {modal.secondaryAction && (
                <VFButton
                  type={order.loading ? 'primary' : 'secondary'}
                  title={modal.secondaryLabel || 'shake_button_close'}
                  onPress={() => modal.secondaryAction()}
                  style={styles.lastModalButton}
                  disabled={order.loading}
                  isLoading={order.loading && order.button === 2}
                  loadingTitle={'Processing...'}
                />
              )}
            </View>
          </Modal>
          <Modal
            visible={error.isVisible}
            close={() => dismissError()}
            onModalHide={() => error.onHide?.()}
            contentContainerStyle={styles.modal}>
            <View style={styles.modalContentContainerWraper(insets.bottom, themeColors)}>
              <View style={styles.modalContentWraper}>
                <Icon
                  name={images.warning}
                  size={48}
                  type="image"
                  resizeMode="contain"
                />
                <VfText
                  weight="bold"
                  size="h3"
                  align="center"
                  style={styles.verticalSpacing}
                  isLoading={isContentLoading}
                  i18nKey={error.title}
                  color={themeColors.colors.textColor}
                />
                <VfText
                  align="center"
                  isLoading={isContentLoading}
                  i18nKey={error.desc}
                  color={themeColors.colors.textColor}
                />
              </View>
              <VFButton
                type="primary"
                title={error.primaryLabel || 'shake_button_go_back'}
                onPress={() => error.primaryAction?.()}
                style={
                  error.secondaryAction
                    ? styles.modalButton
                    : styles.lastModalButton
                }
              />
              {error.secondaryAction && (
                <VFButton
                  type="secondary"
                  title={error.secondaryLabel || ''}
                  onPress={() => error.secondaryAction()}
                  style={styles.lastModalButton}
                />
              )}
            </View>
          </Modal></>
      )
    }
  }


  return (
    // <LinearGradient
    //   colors={gradient}
    //   useAngle={true}
    //   angleCenter={{ x: 0.5, y: 0.5 }}
    //   angle={30}
    //   style={styles.background}
    // >
    <ImageBackground source={background} style={styles.background}>
      <StatusBar
        barStyle="light-content"
        translucent
        backgroundColor={'transparent'}
        animated
        showHideTransition="fade"
      />
      <SafeAreaView
        style={styles.container}
        edges={['right', 'left', 'bottom']}>
        <View style={styles.headerContentWrapper(insets.top)}>
          <TouchableOpacity onPress={() => displayDetails()} disabled={!onClose}>
            <Icon
              name={images.info}
              type="image"
              resizeMode="contain"
              size={48}
            // style={styles.closeIcon(accent)}
            />
          </TouchableOpacity>
          <VfText i18nKey="shake_title" size="h4" color={accent} />
          <TouchableOpacity onPress={closeScreen} disabled={!onClose}>
            <Icon
              name={images.close}
              type="image"
              resizeMode="contain"
              size={24}
              style={styles.closeIcon()}
            />
          </TouchableOpacity>
        </View>
        <ScrollView contentContainerStyle={styles.fillRemaining} bounces={false}>
          {Platform.OS === 'web' && Dimensions.get('window').width > 700 ? renderShakeContentWeb() : renderShakeContent()}
        </ScrollView>
        {renderModals()}
      </SafeAreaView>
    </ImageBackground>
    // </LinearGradient>
  )
}

Shake.defaultProps = {
  onClose: () => { },
  getProducts: () => { }
}

Shake.propTypes = {
  isContentLoading: PropTypes.bool,
  onClose: PropTypes.func,
  navigateToBundles: PropTypes.func,
  getProducts: PropTypes.func,
  productDetails: PropTypes.object,
  orderProduct: PropTypes.func
}

export default Shake
